import { Link } from 'react-router-dom';

export default function EditorialTrust() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Team Image */}
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="w-full h-[320px] md:h-[380px] rounded-3xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20editorial%20office%20interior%20with%20two%20professionals%20collaborating%20at%20a%20sleek%20wooden%20desk%20reviewing%20product%20catalogs%20on%20a%20large%20monitor%2C%20warm%20cream%20walls%2C%20abundant%20natural%20daylight%20streaming%20through%20tall%20windows%2C%20potted%20plants%20in%20corners%2C%20minimalist%20Scandinavian%20decor%2C%20calm%20focused%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20warm%20neutral%20tones%2C%20no%20visible%20screen%20text&width=800&height=600&seq=trust-team-photo-new-42&orientation=landscape"
                alt="Team editoriale Itaobuy Spreadsheet"
                className="w-full h-full object-cover"
                title="Itaobuy Research Team — indipendenza e trasparenza"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-3/5">
            <p className="text-xs text-foreground-500 font-label tracking-wide mb-3">(Team Editoriale)</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-2">
              Indipendenza
            </h2>
            <h3 className="text-2xl md:text-3xl font-heading font-light text-foreground-400 mb-8">
              e Trasparenza
            </h3>

            <div className="relative pl-6 border-l-2 border-accent-300">
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed italic">
                &ldquo;Il nostro impegno è fornire informazioni accurate, verificate e sempre aggiornate sul mondo Itaobuy Spreadsheet. Ogni guida viene revisionata dal nostro team editoriale prima della pubblicazione, garantendo standard qualitativi elevati e totale trasparenza verso i nostri lettori.&rdquo;
              </p>
            </div>

            <p className="mt-6 text-sm font-label font-semibold text-foreground-900">
              &mdash; Itaobuy Research Team, Luglio 2026
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/cos-e-itaobuy-spreadsheet"
                className="px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-label font-medium cursor-pointer whitespace-nowrap hover:bg-foreground-100 transition-colors"
              >
                Leggi la Guida Completa
              </Link>
              <Link
                to="/come-funziona-itaobuy"
                className="px-5 py-2.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-label font-medium cursor-pointer whitespace-nowrap hover:bg-foreground-100 transition-colors"
              >
                Tutorial Passo Passo
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-xs font-label font-medium cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-colors"
              >
                Visita il Sito Principale
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}